import script from "./ServicePageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicePageLayout.vue?vue&type=script&setup=true&lang=js"

import "./ServicePageLayout.vue?vue&type=style&index=0&id=32939038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32939038"]])

export default __exports__